'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface ServicePackageCardProps {
  icon: 'BuildingOfficeIcon' | 'DocumentTextIcon' | 'LightBulbIcon' | 'GlobeAltIcon';
  title: string;
  subtitle: string;
  price: string;
  description: string;
  details: string[];
}

export default function ServicePackageCard({
  icon,
  title,
  subtitle,
  price,
  description,
  details,
}: ServicePackageCardProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="bg-card border-2 border-primary/20 rounded-2xl p-8 hover:shadow-xl hover:border-primary/40 transition-all">
      <div className="flex items-start justify-between mb-6">
        <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center shadow-md">
          <Icon name={icon} size={28} className="text-primary" />
        </div>
        <div className="text-right">
          <div className="text-3xl font-bold text-primary">{price}</div>
          <div className="text-xs text-muted-foreground">zzgl. Umsatz-Zuschlag</div>
        </div>
      </div>

      <h3 className="text-2xl font-serif text-foreground mb-2">{title}</h3>
      <p className="text-sm text-muted-foreground mb-4 italic">{subtitle}</p>
      <p className="text-muted-foreground leading-relaxed mb-6">{description}</p>

      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between px-4 py-3 border-2 border-primary/30 rounded-lg hover:bg-primary/5 hover:border-primary/50 transition-all text-sm font-medium text-foreground"
      >
        <span>{expanded ? 'Details ausblenden' : 'Details anzeigen'}</span>
        <Icon
          name={expanded ? 'ChevronUpIcon' : 'ChevronDownIcon'}
          size={20}
          className="text-foreground"
        />
      </button>

      {expanded && (
        <div className="mt-6 space-y-3 animate-fade-in">
          {details.map((detail, index) => (
            <div key={`detail_${index}`} className="flex items-start gap-3">
              <Icon name="CheckCircleIcon" size={20} className="text-secondary mt-0.5 flex-shrink-0" />
              <span className="text-sm text-muted-foreground">{detail}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}